import dynamic from 'next/dynamic';
import A from './components/US/A';
import B from './components/US/B';
const C = dynamic(() => import('./components/US/C').then((mod) => mod.default), { ssr: false });
import D from './components/US/D';
import E from './components/US/E';
import F from './components/US/F';
const G = dynamic(() => import('./components/US/G').then((mod) => mod.default), { ssr: false });
import H from './components/US/H';
const I = dynamic(() => import('./components/US/I').then((mod) => mod.default), { ssr: false });
import J from './components/US/J';
const K = dynamic(() => import('./components/US/K').then((mod) => mod.default), { ssr: false });
const L = dynamic(() => import('./components/US/L').then((mod) => mod.default), { ssr: false });
const M = dynamic(() => import('./components/US/M').then((mod) => mod.default), { ssr: false });
import EfScrollAni from '@/efscrollani';
import './components/US/index.scss';

function Page() {
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }
    return (
        <>
            <A />
            <B />
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
            <M />
        </>
    );
}

export default Page;
